// extracted by mini-css-extract-plugin
export var hideEditor = "_nn-2";
export var infoIcon = "_nn-3";
export var label = "_nn-1";
export var labelContainer = "_nn-0";
export var readonlyText = "_nn-4";